import { render, staticRenderFns } from "./ScrollToBottom.vue?vue&type=template&id=712a5b79&scoped=true"
import script from "./ScrollToBottom.vue?vue&type=script&lang=js"
export * from "./ScrollToBottom.vue?vue&type=script&lang=js"
import style0 from "./ScrollToBottom.vue?vue&type=style&index=0&id=712a5b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a5b79",
  null
  
)

export default component.exports